"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=/([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g;exports.default=t=>(String(null!=t?t:"").match(e)||[]).map((e=>e.toLowerCase())).join("-");
